import React, { useState } from 'react'
import ProductProfileCard from './productProfileCard'
import { Element } from 'react-scroll'

import './productProfile.scss'

const ProdProfileWrapper = ({ buttons, cards }) => {
	const [profile, setProfile] = useState('astrea')

	function switchProfiles(param) {
		setProfile(param)
	}

	return (
		<div className="productProfile">
			<div className="productProfile_buttonWrapper">
				{buttons.map((btn) => (
					<a
						className={`productProfile_btn ${btn.id}${
							profile === btn.id ? ' selected' : ''
						}`}
						href={btn.link}
						spy={true}
						smooth={true}
						duration={500}
						offset={-200}
						key={btn.id}
						onClick={() => switchProfiles(btn.id)}
					>
						{btn.text}
					</a>
				))}
			</div>
			<Element name="profile" />
			<div className="productProfile_cardWrapper">
				{cards.map((card) => (
					<ProductProfileCard
						key={card.id}
						id={card.id}
						logo={card.logo}
						text={card.text}
						buttons={card.buttons}
						active={profile === card.id && 'selected'}
						customOnClick={() => switchProfiles(card.id)}
					/>
				))}
			</div>
		</div>
	)
}

export default ProdProfileWrapper
